import type {
  languageOptionType,
  languageSelectOptionType,
  localeCodeType,
} from "./types";

export const localeCodes: localeCodeType[] = [
  { localeName: "en", localeCode: "en-US" },
  { localeName: "de", localeCode: "de-DE" },
  { localeName: "sk", localeCode: "sk-SK" },
  { localeName: "hu", localeCode: "hu-HU" },
  { localeName: "fr", localeCode: "fr-FR" },
  //{ localeName: "it", localeCode: "it-IT" },
  { localeName: "es", localeCode: "es-ES" },
  { localeName: "ee", localeCode: "et-EE" },
  { localeName: "pt", localeCode: "pt-BR" },
  { localeName: "bg", localeCode: "bg-BG" },
  { localeName: "ro", localeCode: "ro-RO" },
  { localeName: "sr", localeCode: "sr-Latn-RS" },
  { localeName: "ja", localeCode: "ja-JP" },
];

export const memoringRegisterLocaleCodes: localeCodeType[] = [
  { localeName: "en", localeCode: "en-US" },
  { localeName: "de", localeCode: "de-DE" },
  { localeName: "hu", localeCode: "hu-HU" },
  { localeName: "fr", localeCode: "fr-FR" },
  //{ localeName: "it", localeCode: "it-IT" },
  { localeName: "ro", localeCode: "ro-RO" },
];

export const jinnyRegisterLocaleCodes: localeCodeType[] = [
  { localeName: "en", localeCode: "en-US" },
  { localeName: "de", localeCode: "de-DE" },
  { localeName: "sk", localeCode: "sk-SK" },
  { localeName: "hu", localeCode: "hu-HU" },
  { localeName: "fr", localeCode: "fr-FR" },
  //{ localeName: "it", localeCode: "it-IT" },
  { localeName: "es", localeCode: "es-ES" },
  { localeName: "pt", localeCode: "pt-BR" },
  { localeName: "ro", localeCode: "ro-RO" },
  { localeName: "bg", localeCode: "bg-BG" },
  { localeName: "sr", localeCode: "sr-Latn-RS" },
];

export const translationNames = [
  { localeName: "en", fileName: "en.json" },
  { localeName: "de", fileName: "en.de-DE.json" },
  { localeName: "sk", fileName: "en.sk-SK.json" },
  { localeName: "es", fileName: "en.es-ES.json" },
  { localeName: "hu", fileName: "en.hu-HU.json" },
  //{ localeName: "it", fileName: "en.it-IT.json" },
  { localeName: "fr", fileName: "en.fr-FR.json" },
  { localeName: "pt", fileName: "en.pt-BR.json" },
  { localeName: "bg", fileName: "en.bg-BG.json" },
  { localeName: "ro", fileName: "en.ro-RO.json" },
  { localeName: "sr", fileName: "en.sr-Latn-RS.json" },
  { localeName: "ee", fileName: "en.et-EE.json" },
  { localeName: "ja", fileName: "en.ja-JP.json" },
];

export const userLanguageOptions: languageSelectOptionType[] = [
  { label: "en", value: "en-US" },
  { label: "de", value: "de-DE" },
  { label: "sk", value: "sk-SK" },
  { label: "hu", value: "hu-HU" },
  { label: "ro", value: "ro-RO" },
  { label: "sr", value: "sr-Latn-RS" },
];

export function getLocaleFileName(locale: string) {
  const fileName = translationNames.find((item) => item.localeName === locale);
  return fileName?.fileName || "en.json";
}

/**
 * languageOptions - all available language used for url path
 */
function getLangOptions() {
  return localeCodes.map((lang) => ({ lang: lang.localeName }));
}

export const languageOptions: languageOptionType[] = getLangOptions();

export function getCurrentLocale() {
  if (typeof window !== "undefined" && window.localStorage) {
    const locale = localStorage.getItem("currentLocale") || "";
    const code = localeCodes.find(
      (item) => item.localeName === locale && JSON.parse(locale)
    );
    return code?.localeCode;
  }
  return "";
}

export function getLanguageSelectOptions(): languageSelectOptionType[] {
  return localeCodes.map((item: localeCodeType) => ({
    label: item.localeCode,
    value: item.localeCode,
  }));
}
